import React, { useState } from "react";
import { Link } from "react-router-dom";
import { List, ListItemButton, ListItemText, Menu } from "@mui/material";
import { AngleIcon } from "../../Icons";

const HeaderExpertise = () => {
  const [headerMenuEl, setHeaderMenuEl] = useState(null);
  const headerMenuOpen = Boolean(headerMenuEl);
  const headerMenuOpenReq = (event) => {
    setHeaderMenuEl(event.currentTarget);
  };
  const headerMenuClose = () => {
    setHeaderMenuEl(null);
  };

  return (
    <>
      <div
        className={`managepro6ix-layout-header-right-item-btn managepro6ix-layout-header-right-item-btn-full ${
          headerMenuOpen ? "active" : ""
        }`}
        id="header-expertise-menu-button"
        aria-controls={headerMenuOpen ? "header-expertise-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={headerMenuOpen ? "true" : undefined}
        onClick={headerMenuOpenReq}
      >
        <div className="managepro6ix-layout-header-right-item-btn-text">
          Share Expertise
        </div>
        {headerMenuOpen ? <AngleIcon up /> : <AngleIcon small />}
      </div>

      <Menu
        id="header-expertise-menu"
        anchorEl={headerMenuEl}
        open={headerMenuOpen}
        onClose={headerMenuClose}
        MenuListProps={{
          "aria-labelledby": "header-expertise-menu-button",
        }}
        className="managepro6ix-layout-header-right-item-dropdown managepro6ix-layout-header-right-item-dropdown-users"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <List
          component="nav"
          className="managepro6ix-layout-header-right-item-dropdown-users-list"
        >
          <ListItemButton
            className="managepro6ix-layout-header-right-item-dropdown-users-list-item"
            component={Link}
            to="https://events.6ix.com/6ix/broadcast"
            onClick={headerMenuClose}
          >
            <ListItemText
              className="managepro6ix-layout-header-right-item-dropdown-users-list-item-text"
              primary="Broadcast Interviews"
            />
          </ListItemButton>
        </List>
      </Menu>
    </>
  );
};

export default HeaderExpertise;
